import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../../lib/utils"

const headingVariants = cva(
  "font-jakarta text-foreground",
  {
    variants: {
      level: {
        1: "text-figma-2xl tracking-[-0.02em]",  // Page titles
        2: "text-figma-xl tracking-[-0.01em]",   // Section titles
        3: "text-figma-lg tracking-[-0.01em]",   // Card/panel titles
        4: "text-figma-base",                    // Subsection titles
        5: "text-figma-sm uppercase tracking-[0.05em]", // Small section titles
        6: "text-figma-xs uppercase tracking-[0.05em]", // Smallest titles
      },
      weight: {
        bold: "font-bold",
        extrabold: "font-extrabold",
        semibold: "font-semibold",
        medium: "font-medium",
      }
    },
    defaultVariants: {
      level: 3,
      weight: "bold",
    }
  }
)

export interface HeadingProps
  extends React.HTMLAttributes<HTMLHeadingElement>,
    VariantProps<typeof headingVariants> {
  level?: 1 | 2 | 3 | 4 | 5 | 6
  weight?: "extrabold" | "bold" | "semibold" | "medium"
}

const Heading = React.forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ className, level = 3, weight, children, ...props }, ref) => {
    const Tag = `h${level}` as const
    return React.createElement(
      Tag,
      {
        ref,
        className: cn(headingVariants({ level, weight }), className),
        ...props
      },
      children
    )
  }
)
Heading.displayName = "Heading"

export { Heading, headingVariants }
